<template>
<div>
    <div class="desktop">
        <b-list-group class="mt-5 ">
            <b-list-group-item :active="recipes" href="/recipes">All Recipes</b-list-group-item>
            <b-list-group-item :active="created" href="#" @click="gotoCreatedRecipes">Created Recipes
            </b-list-group-item>
            <b-list-group-item :active="manage" href="#" @click="gotoManageRecipes">Recipe Hirings
            </b-list-group-item>
            <b-list-group-item :active="purchase" href="#" @click="gotoPurchasedRecipes">Purchased Recipes
            </b-list-group-item>
            <b-list-group-item :active="create" href="#" @click="gotoRecipe">Add Recipe</b-list-group-item>
        </b-list-group>
    </div>
    <div class="mobile">
        <b-icon @click="handleOpen" icon="list" scale="2"></b-icon>
        <div class="slide-menu card" :id="menuId" v-click-outside="handleHide">
            <b-list-group>
                <b-list-group-item :active="recipes" href="/recipes">All Recipes</b-list-group-item>
                <b-list-group-item :active="created" href="#" @click="gotoCreatedRecipes">Created Recipes
                </b-list-group-item>
                <b-list-group-item :active="manage" href="#" @click="gotoManageRecipes">Recipe Hirings
                </b-list-group-item>
                <b-list-group-item :active="purchase" href="#" @click="gotoPurchasedRecipes">Purchases
                </b-list-group-item>
                <b-list-group-item :active="create" href="#" @click="gotoRecipe">Add Recipe</b-list-group-item>
            </b-list-group>
        </div>

    </div>
</div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
    name: 'recipe-sidebar',
    props: ['create', 'created', 'recipes', 'manage', 'menuId','purchase'],
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },

    methods: {
        handleOpen() {
            this.$emit('handleOpen')
        },
        handleHide() {
            this.$emit('handleHide')
        },
        gotoRecipe() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/recipes/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-recipe-listing",
                });
            }
        },
        gotoCreatedRecipes() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/recipes/created",
                    },
                });
            } else {
                this.$router.push({
                    name: "created-recipe-listings",
                });
            }
        },
        gotoManageRecipes() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/recipes/hires",
                    },
                });
            } else {
                this.$router.push({
                    name: "recipe-hirings",
                });
            }
        },
        gotoPurchasedRecipes() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/recipes/purchases",
                    },
                });
            } else {
                this.$router.push({
                    name: "purchased-recipes",
                });
            }
        }
    }
}
</script>

<style scoped>
.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center;
}

.slide-menu {
    position: absolute;
    z-index: 999;
    background: #fff;
    margin-left: -360px;
    width: 328%;
    top: 0px;
    padding-left: 16px;
    transition: all 0.4s ease-in-out;
}
</style>
